import { connect } from "react-redux";

import {
  selectUserId,
  selectUserEmail,
  selectRoles
} from "selector/authSelectors";
import { getUserClientName } from "selector/userSelectors";
import Pendo from "./Pendo";

const mapStateToProps = state => {
  const props = {
    apiKey: window.__PENDO_KEY__,
    visitor: {
      id: selectUserId(state)
    },
    account: {
      id: getUserClientName(state)
    }
  };

  const email = selectUserEmail(state);
  if (email && email.length) {
    props.visitor.email = email;
  }

  const roles = selectRoles(state);
  if (roles && roles.length) {
    props.visitor.role = roles.join(",");
  }

  return props;
};

export default connect(mapStateToProps)(Pendo);
